<template>
  <div>
    <el-row class="bg-color-w py-20 px-30">
      <el-row class="mt-10">
        <!-- 动态表格组件 -->
        <TableCommon
          v-loading="tabLoading"
          :element-loading-text="$t('elTable.loadingText')"
          element-loading-spinner="el-icon-loading"
          :tableColumns="tableColumns"
          :tableData="tableData"
          :uniqueNum="uniqueNum"
          :searchPlaceholder="$t('xmsq.searchPlaceholder')"
          :cellStyle="$store.state.cellStyle"
          :headerCellStyle="$store.state.headerCellStyle"
          :height="$store.state.screenHeight - 210"
          @handleClickFun="handleClickFun"
          :rowStylefilter="['departmentName','projectName']"
        ></TableCommon>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import * as sqgl from "@/api/sqgl";

export default {
  // 项目变更通知
  name: "projectChangeNotice",
  computed: {},
  data() {
    return {
      tabLoading: false,
      tableColumns: [],
      tableData: [],
      tableData1: [],
      tableData2: [],
      uniqueNum: "Y120119-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      yhxx: this.$store.state.yhxx.yhxx,
      bsqr: "",
      flg: "0",
      saveflg: "0",
      rydm: null,
      activeBtn: "1",
      fileTemp: null,
      fileList: [],
      search: "",
    };
  },
  methods: {
    // 获取负责人项目
    getXmsqinfo() {
      this.tabLoading = true;
      sqgl.getXmsqinfo().then((res) => {
        if (res.data.code == "200") {
          this.tabLoading = false;
          res.data.data.forEach((item, index) => {
            item.departmentName = "(" + item.bmbh + ")" + item.bmmc;
            item.projectName = "(" + item.xmbh + ")" + item.xmmc;
            item.shortNote = item.isdx == "1" ? true : false;
          });
          this.tableData = res.data.data;
        }
      });
    },

    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      let params = {};
      params.pageId = "Y120119";
      params.moduleId = "1";
      params.groupId = "1";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns = tmpResult;
      });
      this.getXmsqinfo();
    },

    // 更改是否开启通知
    kqdxtz(row) {
      if (row.shortNote) {
        row.isdx = "1";
      } else {
        row.isdx = "0";
      }
      sqgl.setXmisdx(row).then((res) => {
        if (res.data.code == "200") {
          this.$message.success(res.data.message);
          this.getXmsqinfo();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 点击按钮或链接
    handleClickFun(row) {
      //   console.log(row);
      if (row.oprationflg == "是否开启短信通知") {
        this.kqdxtz(row.row);
      }
    },

    // 自定义过滤
    searchFilter(val) {
      this.search = val;
    },
    // 项目授权过滤
    rowStyle(val) {
      let row = val.row;
      if (this.search == "") {
        return;
      } else {
        if (
          row.departmentName
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          row.projectName.toLowerCase().includes(this.search.toLowerCase())
        ) {
          return;
        } else {
          return {
            display: "none",
          };
        }
      }
    },
  },
  mounted() {
    this.getPageTableConfig();
  },
};
</script>

<style lang="scss"></style>
